module.exports = __webpack_public_path__ + "img/Q&A.0046bfc6.png";